import { Address } from 'src/app/user/user.model';
import { Observable } from 'rxjs';
import { SearchAddressPayload } from './geoid.model';

export abstract class GeoidService {
    public abstract searchAddress(address: SearchAddressPayload): Observable<Address[]>;

    public abstract forceSearchAddress(address: SearchAddressPayload): Observable<Address[]>;

    public abstract searchAddressQuery(query: string): Observable<Address[]>;

    public abstract forceSearchAddressQuery(query: string): Observable<Address[]>;
}
